import { IMyPokeTractor, IUserOwnTractorCommon } from '../../../interfaces/OwnTractor.interfaces';
import { customAxios } from '../../common/customAxios';
import { myOwnTractorsApiUrl } from './getMyOwnTractors';

export const getMyPokeTractors = (): Promise<IMyPokeTractor[]> => {
  return customAxios.get(`${myOwnTractorsApiUrl}/pokes`);
};
